import React, { useState, useEffect, use } from 'react';
import { Button, Checkbox, FloatButton, Modal, Select, Spin, Tag, Avatar } from 'antd';
import styles from './Dashboard.module.scss';
import CommonHeader from '../CommonHeader';
import ItemTypeModal from '../ItemTypeModal';
import { navigateWithAuth } from '../../utils/navigationUtils';

import Search from 'antd/es/input/Search';
import DashboardImgs from '../../util/Images';
import AssetRow, { AssetData } from './AssetRow';
import { ListingType, StatusType } from '../../util/misc';
import TopSectionCharts from './TopSectionCharts';
import DamAssetListing from './DamAssetListing';
import { getDigitalAssets, getMarketplaceList } from '../../api/marketplace';
import { getOrgData } from '../../api/marketplace';


const Dashboard: React.FC = () => {
  const [showItemTypeModal, setShowItemTypeModal] = useState(false);
  const [emptyDashboardAlert, setEmptyDashboardAlert] = useState(false)
  const [loading, setLoading] = useState(true);
  const [damAssets, setDamAssets] = useState<AssetData[]>([]);
  const [marketplaceData, setMarketplaceData] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState<any>(0);
  const [searchText, setSearchText] = useState("");
  const [currentUser, setCurrentUser] = useState<any>(null);

  const statusMark = (item: string, marketplaceStatus?: any) => {
    if (item === 'SP_request_for_approval') {
      return 'Approval Pending'
    } else if (item === 'DA_ready_to_execute') {
      return 'Ready for Approval'
    } else if (item === 'DA_published') {
      return 'Published'
    } else if (item === 'DA_verified') {
      return 'Verified'
    } else if (item === 'DA_inactive') {
      return 'Inactive'
    } else if (item === 'SP_ready_to_tokenise') {
      return 'Ready to Publish'
    } else if (item === 'DA_ready_to_publish') {
      return 'Ready to Publish'
    }
    return ''
  }

  const fetchMarketplaceData = async () => {
    try {
      const response = await getMarketplaceList();
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching marketplace data:', error);
      return [];
    }
  }

  const fetchAssets = async (mpData: any[] = [],orgData: any[] = [] ) => {
    setLoading(true)
    let authUser = localStorage.getItem('authUser') || ''
    let localStoredObject = JSON.parse(authUser)

    try {
      const { data, total } = await getDigitalAssets({
        orgId: localStoredObject?.org_id,
        page: currentPage,
        pageSize,
        search: searchText,
      });

      const assetMap = data.map((item: any) => {
        const category = item?.attributes?.find((attr: any) => attr?.fieldName === "itemType")?.value ?? "-";
        const marketplaceItem = mpData.find((mp: any) => mp.damId === item?.id);
        const matchedData = orgData?.find((org: { damId: string }) => org.damId === item?.id);
        return {
          id: item?.id,
          productName: item?.displayName,
          assetImage: item?.iconUrl,
          category: category,
          totalSales: 0,
          transactions: 0,
          listing: "Public",
          status: statusMark(item?.state, marketplaceItem?.approvedStatus),
          buttonStatus: matchedData ? matchedData.status ==="active" ? "Applied for Paid Promotion": matchedData.status === "cancelled" ? "Promotion Cancelled" : "Other" : "Promote",
          rawState: item?.state,
          marketplaceApprovedStatus: marketplaceItem?.approvedStatus,
          marketplaceData: marketplaceItem || null,
        }
      });
      
      // Check if data is empty and no search text
      if (assetMap.length === 0 && searchText === '') {
        setEmptyDashboardAlert(true);
      } else {
        setEmptyDashboardAlert(false);
      }
      
      setDamAssets(assetMap);
      setMarketplaceData(mpData);
      setTotalCount(total);
      setLoading(false);

    } catch (e) {
      setLoading(false)
      console.error(e);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      const mpData = await fetchMarketplaceData();
      const orgData = await getOrgData()
      await fetchAssets(mpData, orgData.data);
    };
    loadData();
  }, [currentPage, pageSize, searchText])
  useEffect(() => {
    const currentUser = localStorage.getItem('authUser') || ''
    setCurrentUser(JSON.parse(currentUser))
  },[])
  const handleZeroAssetFun = (value: boolean) => {
    setEmptyDashboardAlert(value); 
  };

  const DamEmpty = () =>{
    return <div className={styles.dashboardEmpty}>
         <img src={DashboardImgs.NoContentImg}/>
         <h2>It's looking a little quiet in here...</h2>
         <p>Your dashboard is empty because you haven't listed any products yet. List your first item and start reaching customers today.</p>
         <div>
           <Button type="primary" className={styles.addItemBtn} onClick={() => setShowItemTypeModal(true)}>
              Add New Item
          </Button>
         </div>
       </div> 
  }
 

  return (
    <div className={styles.dashboardContainer}>
      <CommonHeader />
      <ItemTypeModal
        visible={showItemTypeModal}
        onCancel={() => setShowItemTypeModal(false)}
      />

       <main className={styles.dashboardMain}>  

              
        <section className={styles.seller_header}>
          <div className={styles.seller_details}>
            <div className={styles.seller_logo}>
              <Avatar
                size={80}
                className={styles.sellerAvatar}
              >
                {`${currentUser?.given_name?.[0] || ''}${currentUser?.family_name?.[0] || ''}`}
              </Avatar>
            </div>
            {/* <div className={styles.seller_logo}><img src={DashboardImgs.Logo} /> </div> */}
            <div className={styles.seller_name}>
              <span>Seller</span>
              <h3>{currentUser?.name || ''}</h3>
              <span className={styles.trused_btn}>
                <i>Verified Seller</i>
                <img src={DashboardImgs.VerifiedIcon}  />
              </span>
            </div>
          </div>
          {!emptyDashboardAlert && <Button type="primary" className={styles.addItemBtn} onClick={() => setShowItemTypeModal(true)}>
              Add New Item
          </Button>}
        </section>

        {/* {emptyDashboardAlert &&  <TopSectionCharts/>} */}

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
            <Spin size="large" />
          </div>
        ) : emptyDashboardAlert ? (
          <DamEmpty/>
        ) : (
          <DamAssetListing 
            damAssets={damAssets}
            marketplaceData={marketplaceData}
            pageSize={pageSize}
            currentPage={currentPage}
            totalCount={totalCount}
            searchText={searchText}
            onPageChange={(page, size) => {
              setCurrentPage(page);
              if (size) setPageSize(size);
            }}
            onPageSizeChange={(_: number, size: number) => {
              setCurrentPage(1);
              setPageSize(size);
            }}
            onSearchChange={(value: string) => {
              setSearchText(value);
              setCurrentPage(1);
            }}
            onRefreshData={async () => {
              const mpData = await fetchMarketplaceData();
              const orgData = await getOrgData()
              await fetchAssets(mpData, orgData.data);
            }}
          />
        )}
        
        

        

       
      </main>
      
      
      
      
      
    </div>
  );
};

export default Dashboard;